// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.ui-check-box[data-v-2b98caa8] {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
label[data-v-2b98caa8] {
  position: relative;
  display: flex;
}
input[data-v-2b98caa8] {
  display: none;
  background-color: transparent;
}
.check-box-square[data-v-2b98caa8] {
  border: 1px solid var(--input-color);
  height: 1rem;
  min-width: 1rem;
  display: block;
  margin-right: 0.5rem;
  position: relative;
  transition: border-color var(--input-time) ease-in-out;
}
.check-box-square[data-v-2b98caa8]::after {
  content: '';
  position: absolute;
  top: -3%;
  left: 30%;
  width: 40%;
  height: 80%;
  border-right: 1px solid var(--button-primary-background);
  border-bottom: 1px solid var(--button-primary-background);
  opacity: 0;
  transform: rotateZ(35deg);
  transition: opacity var(--input-time) ease-in-out;
}
.check-box-name[data-v-2b98caa8] {
  color: var(--text-contrast-color);
  display: block;
}
.check-box-square[data-v-2b98caa8],
.check-box-name[data-v-2b98caa8] {
  margin-top: auto;
  margin-bottom: auto;
  cursor: pointer;
}
.check-box-error[data-v-2b98caa8] {
  font-size: 0.75rem;
  color: var(--error);
  position: absolute;
  bottom: -1rem;
  opacity: 0;
  transition: opacity var(--input-time) ease-in-out;
}
input:checked + .check-box-square[data-v-2b98caa8]::after {
  opacity: 1;
}
.ui-touched .check-box-error[data-v-2b98caa8] {
  opacity: 1;
}
.has-error.ui-touched[data-v-2b98caa8] {
  --input-color: var(--error);
}
.has-error.ui-touched .check-box-name[data-v-2b98caa8] {
  color: var(--error);
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/UiCheckBox.vue"],"names":[],"mappings":";AAkDA;EACA,iBAAA;EACA,oBAAA;AACA;AAEA;EACA,kBAAA;EACA,aAAA;AACA;AAEA;EACA,aAAA;EACA,6BAAA;AACA;AAEA;EACA,oCAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,sDAAA;AACA;AAEA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,wDAAA;EACA,yDAAA;EACA,UAAA;EACA,yBAAA;EACA,iDAAA;AACA;AAEA;EACA,iCAAA;EACA,cAAA;AACA;AAEA;;EAEA,gBAAA;EACA,mBAAA;EACA,eAAA;AACA;AAEA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,iDAAA;AACA;AAEA;EACA,UAAA;AACA;AAEA;EACA,UAAA;AACA;AAEA;EACA,2BAAA;AACA;AAEA;EACA,mBAAA;AACA","sourcesContent":["<template>\n  <div class=\"ui-check-box\">\n    <label :class=\"[{ 'has-error': error }, touchedClass]\">\n      <input\n        type=\"checkbox\"\n        :value=\"true\"\n        :checked=\"value\"\n        :disabled=\"disabled\"\n        @input=\"$emit('input', $event.target.checked)\"\n        @change=\"onChange\"\n      />\n      <i class=\"check-box-square\" />\n      <span class=\"check-box-name\">{{ $t(label) }}</span>\n      <span class=\"check-box-error\">{{ $t(error) }}</span>\n    </label>\n  </div>\n</template>\n\n<script>\nexport default {\n  name: 'ui-check-box',\n\n  props: {\n    label: { type: String, default: undefined },\n    error: { type: String, default: undefined },\n    value: Boolean,\n    disabled: Boolean\n  },\n\n  data() {\n    return {\n      isTouched: false\n    }\n  },\n\n  computed: {\n    touchedClass() {\n      return this.isTouched ? 'ui-touched' : 'ui-untouched'\n    }\n  },\n\n  methods: {\n    onChange() {\n      this.isTouched = true\n    }\n  }\n}\n</script>\n\n<style scoped>\n.ui-check-box {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\nlabel {\n  position: relative;\n  display: flex;\n}\n\ninput {\n  display: none;\n  background-color: transparent;\n}\n\n.check-box-square {\n  border: 1px solid var(--input-color);\n  height: 1rem;\n  min-width: 1rem;\n  display: block;\n  margin-right: 0.5rem;\n  position: relative;\n  transition: border-color var(--input-time) ease-in-out;\n}\n\n.check-box-square::after {\n  content: '';\n  position: absolute;\n  top: -3%;\n  left: 30%;\n  width: 40%;\n  height: 80%;\n  border-right: 1px solid var(--button-primary-background);\n  border-bottom: 1px solid var(--button-primary-background);\n  opacity: 0;\n  transform: rotateZ(35deg);\n  transition: opacity var(--input-time) ease-in-out;\n}\n\n.check-box-name {\n  color: var(--text-contrast-color);\n  display: block;\n}\n\n.check-box-square,\n.check-box-name {\n  margin-top: auto;\n  margin-bottom: auto;\n  cursor: pointer;\n}\n\n.check-box-error {\n  font-size: 0.75rem;\n  color: var(--error);\n  position: absolute;\n  bottom: -1rem;\n  opacity: 0;\n  transition: opacity var(--input-time) ease-in-out;\n}\n\ninput:checked + .check-box-square::after {\n  opacity: 1;\n}\n\n.ui-touched .check-box-error {\n  opacity: 1;\n}\n\n.has-error.ui-touched {\n  --input-color: var(--error);\n}\n\n.has-error.ui-touched .check-box-name {\n  color: var(--error);\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
